import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class DeleteUser extends Component {
    render() {
        return (
            <Modal isOpen={this.props.modal}>
                <ModalHeader toggle={this.props.toggle}>Delete User</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this user ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.props.submitDeleteUser}>Yes</Button>
                    <Button color="secondary" className="ml-2" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default DeleteUser
